export default "__VITE_ASSET__M3M9SoTw__"